/**
 * Separator Component: How-To Schema
 */
const HowToChildSeparator = () => {
	return (
		<div className="wpsp-ifb-separator-parent">
			<div className="wpsp-ifb-separator"></div>
		</div>
	);
};

export default HowToChildSeparator;
